import React, { useMemo } from 'react';
import { useTranslation } from 'utils/i18n';
import LegalLayout from 'components/legal/LegalLayout';
import { mapPrivacyPolicyToSections } from 'utils/legal/sections';

const PrivacyPolicy = () => {
  const { t, language } = useTranslation();
  
  // Re-compute sections when language changes
  const sections = useMemo(() => mapPrivacyPolicyToSections(t), [language]);
  const title = t('title', 'privacy') || 'Privacy Policy';
  const lastUpdated = t('lastUpdated', 'privacy') || '';

  return <LegalLayout title={title} lastUpdated={lastUpdated} sections={sections} />;
};

export default PrivacyPolicy;
